import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/css/App.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

/**
 * Bitta build ichida ikkita ilova yashaydi:
 *   /trip-attendance  -> Telegram mini app (komandirovka davomati)
 *   qolgan hammasi    -> CRM
 *
 * Ikkalasi ham DINAMIK import qilinadi, shuning uchun webpack ularni alohida
 * chunk'larga ajratadi: mini app telefonda ochilganda CRM kodini yuklamaydi.
 * Bu yerga CRM modullarini statik import qilmang - ajratish buziladi.
 */
const MINI_APP_PATH = "/trip-attendance";

const isMiniApp = window.location.pathname.startsWith(MINI_APP_PATH);

const registerServiceWorker = () => {
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        console.log("Service Worker ro‘yxatdan o‘tkazildi:", registration);

        registration.addEventListener("updatefound", () => {
          const newWorker = registration.installing;
          newWorker.addEventListener("statechange", () => {
            if (
              newWorker.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              import("./config/i18n").then(({ default: i18n }) => {
                alert(i18n.t("messages.newVersionAvailable"));
              });
            }
          });
        });
      })
      .catch((error) => {
        console.log("Service Worker ro‘yxatdan o‘tkazishda xatolik:", error);
      });
  });
  navigator.serviceWorker.ready.then((registration) => {
    registration.active.postMessage({ type: "CHECK_UPDATE" });
  });
};

if (isMiniApp) {
  import("./miniapp/tripAttendance/TripAttendanceApp").then(
    ({ default: TripAttendanceApp }) => {
      root.render(<TripAttendanceApp />);
    },
  );
} else {
  registerServiceWorker();

  Promise.all([import("./App.jsx"), import("config/i18n")]).then(
    ([{ default: App }]) => {
      root.render(<App />);
    },
  );
}
